module.exports = __webpack_public_path__ + "img/trashIcon.f974bfd4.svg";